import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria, getBlankRecord, getBlankReconciliationRecord, getBlankDueRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";
import * as mutation from "./mutation-types";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      levyCollectionId: null,
      providerId: null,
      data: [],
      paging: tableHelper.getDefaultPaging("Id", true),
      empty: false,
      loading: false,
      loaded: false
    },
    view: {
      invoiceId: null,
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      loading: false,
      loaded: false
    },
    transactions: [],
    pdf: {
      loading: false
    },
    reconcile: {
      invoiceId: null,
      loading: false
    },
    reconcileTestingTool: {
      invoiceId: null,
      data: getBlankReconciliationRecord(),
      loading: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "reconcileTestingTool"
      }
    },
    due: {
      data: getBlankDueRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "due"
      }
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      empty: false,
      loaded: false
    },
    view: {
      loaded: false
    },
    transactions: []
  };
}
